import React, {Component} from 'react';

class Footer extends Component {

	render() {
		return (
			<footer id="footer">
				<span>codito &copy; 2020</span>
			</footer>
		);
	}
}

export default Footer;
